var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12276 1.12276C1.84165 0.403868 2.81667 0 3.83333 0H14.0556C14.3944 0 14.7195 0.134623 14.9591 0.374252L22.6257 8.04092C22.8654 8.28055 23 8.60556 23 8.94444V24.2778C23 25.2944 22.5961 26.2695 21.8772 26.9884C21.1584 27.7072 20.1833 28.1111 19.1667 28.1111H3.83333C2.81667 28.1111 1.84165 27.7072 1.12276 26.9884C0.403868 26.2695 0 25.2944 0 24.2778V3.83333C0 2.81667 0.403868 1.84165 1.12276 1.12276ZM3.83333 2.55556C3.49445 2.55556 3.16944 2.69018 2.92981 2.92981C2.69018 3.16944 2.55556 3.49445 2.55556 3.83333V24.2778C2.55556 24.6167 2.69018 24.9417 2.92981 25.1813C3.16944 25.4209 3.49445 25.5556 3.83333 25.5556H19.1667C19.5056 25.5556 19.8306 25.4209 20.0702 25.1813C20.3098 24.9417 20.4444 24.6167 20.4444 24.2778V9.47372L13.5263 2.55556H3.83333Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0555 0C14.7612 0 15.3333 0.572081 15.3333 1.27778V7.66667H21.7222C22.4279 7.66667 23 8.23875 23 8.94444C23 9.65014 22.4279 10.2222 21.7222 10.2222H14.0555C13.3499 10.2222 12.7778 9.65014 12.7778 8.94444V1.27778C12.7778 0.572081 13.3499 0 14.0555 0Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11108 15.3325C5.11108 14.6268 5.68316 14.0547 6.38886 14.0547H16.6111C17.3168 14.0547 17.8889 14.6268 17.8889 15.3325C17.8889 16.0382 17.3168 16.6102 16.6111 16.6102H6.38886C5.68316 16.6102 5.11108 16.0382 5.11108 15.3325Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11108 20.4438C5.11108 19.7381 5.68316 19.166 6.38886 19.166H16.6111C17.3168 19.166 17.8889 19.7381 17.8889 20.4438C17.8889 21.1495 17.3168 21.7216 16.6111 21.7216H6.38886C5.68316 21.7216 5.11108 21.1495 5.11108 20.4438Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11108 10.2231C5.11108 9.51739 5.68316 8.94531 6.38886 8.94531H8.94442C9.65011 8.94531 10.2222 9.51739 10.2222 10.2231C10.2222 10.9288 9.65011 11.5009 8.94442 11.5009H6.38886C5.68316 11.5009 5.11108 10.9288 5.11108 10.2231Z",
    fill: "#BCAB79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.577d21172a6c325eb791b7b1c99ed2fa.svg";
export { ForwardRef as ReactComponent };